import { createClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || "";
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || "";
const createOrderEndpoint = import.meta.env.VITE_CREATE_RAZORPAY_ORDER_ENDPOINT || "https://xeylkmnwiefmhjjiezyx.supabase.co/functions/v1/create-razorpay-order";
const verifyPaymentEndpoint = import.meta.env.VITE_VERIFY_RAZORPAY_PAYMENT_ENDPOINT || "https://xeylkmnwiefmhjjiezyx.supabase.co/functions/v1/swift-api";

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn(
    "Supabase configuration is missing. Please set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY in your .env file."
  );
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export const razorpayEndpoints = {
  createOrder: createOrderEndpoint,
  verifyPayment: verifyPaymentEndpoint,
};